import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { loadBasket } from './utils';

export default function* listenLoad() {
  yield takeEvery(basketActions.load.toString(), loadBasket);
}
